import { Button, Checkbox, Form, Input, message, Spin } from "antd";
import { useState } from "react";
import './auth.css';
import { useDispatch } from "react-redux";
import { serverFetch } from "../../server";
import { userLoaded } from "../../redux/actions";
import EnterCode from "../../controls/enter-code/enter-code";

const Auth = () => {
  const d = useDispatch();
  const [form] = Form.useForm();
  const [data, setData] = useState({email: '', checkcode: '', name: ''})
  const [sentCode, setSentCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeId, setCodeId] = useState();
  const [register, setRegister] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  
  const onFinish = () => {}
  const onSendCode = () => {
    setLoading(true);
    serverFetch(`auth/GenerateCheckcode?email=${data.email}&register=${register}&name=${data.name}`)
      .then((data) => {
        setSentCode(true);
        setLoading(false);
        setCodeId(data);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }
  const onChangeValue = (value) => {
    setData({...data, ...value});
  }
  const onLogin = (data) => {
    setLoading(true);
    serverFetch('auth/login', {method: 'POST', bodyData: data})
      .then(session => d(userLoaded(session)))
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }

  const divBusy = loading && <Spin />
  const agree = agree1 && agree2 && data.name && data.email;

return<div>
    <div className='auth-body'>
      <div className='auth-container'>
        <div className="auth-center">
          <img src="/images/logo.svg" className="auth-logo" alt="logo"/>
          <div className="auth-logo-text"><img src="/images/logo-text.svg" alt="logo"/></div>
          {register ? <div className='auth-form'>
            <div className='auth-form-title'>РЕГИСТРАЦИЯ</div>
            <Form size={'large'} form={form} initialValues={{ remember: true }} onFinish={onFinish}>
              <Form.Item className='auth-form-item' name="name">
                <Input placeholder='Наименование клуба' disabled={loading || sentCode} className='auth-form-item-input' onChange={(e) => onChangeValue({name: e.target.value})}/>
              </Form.Item>
              <Form.Item className='auth-form-item' name="email">
                <Input placeholder='Почта' disabled={loading || sentCode} className='auth-form-item-input' onChange={(e) => onChangeValue({email: e.target.value})}/>
              </Form.Item>
              <Form.Item className="auth-checkbox-item"><Checkbox value={agree1} onChange={e => setAgree1(e.target.checked)}>Принимаю <a href="https://profitonik.ru/user_agreement" target="_blank">пользовательское соглашение</a></Checkbox></Form.Item>
              <Form.Item className="auth-checkbox-item"><Checkbox value={agree2} onChange={e => setAgree2(e.target.checked)}>Принимаю <a href="https://profitonik.ru/privacy_policy" target="_blank">политику конфиденциальности</a></Checkbox></Form.Item>
              {sentCode || <Form.Item style={{ marginBottom: 0 }}>
                <Button type='primary' loading={loading} className={'auth-form-btn' + (agree ? '' : ' auth-btn-disabled')} onClick={onSendCode} disabled={!agree}>Отправить код</Button>
                <div className="auth-form-help-link">
                  <a href="https://kb.sport24.cloud/article/registraciya-i-ustanovka-programmnogo-obespecheniya" target="_blank">Регистрация и установка</a>
                  <a href="https://kb.sport24.cloud/article/funkcionalnye-harakteristiki" target="_blank">Функциональные характеристики</a>
                </div>
              </Form.Item>}
              {!loading && sentCode && <Form.Item className='auth-form-item'>
                <div className='auth-enter-code-title'>ВВЕДИТЕ КОД</div>
              </Form.Item>}
              {!loading && sentCode && <Form.Item className='auth-form-item'>
                <EnterCode len={6} onFinish={(checkcode) => {
                    const newData = {...data, checkcode, id: codeId};
                    setData(newData);
                    onLogin(newData);
                  }}/> 
              </Form.Item>}
              
            </Form>
          </div> 
          : <div className='auth-form'>
            <div className='auth-form-title'>ВХОД</div>
            <Form size={'large'} form={form} initialValues={{ remember: true }} onFinish={onFinish}>
              <Form.Item className='auth-form-item' name="email">
                <Input placeholder='Почта' disabled={loading || sentCode} className='auth-form-item-input' onChange={(e) => onChangeValue({email: e.target.value})}/>
              </Form.Item>
              {sentCode || <Form.Item style={{ marginBottom: 0 }}>
                <Button type='primary' loading={loading} className='auth-form-btn' onClick={onSendCode}>Отправить код</Button>
              </Form.Item>}
              {!loading && sentCode && <Form.Item className='auth-form-item'>
                <div className='auth-enter-code-title'>ВВЕДИТЕ КОД</div>
              </Form.Item>}
              {!loading && sentCode && <Form.Item className='auth-form-item'>
                <EnterCode len={6} onFinish={(checkcode) => {
                    const newData = {...data, checkcode, id: codeId};
                    setData(newData);
                    onLogin(newData);
                  }}/> 
              </Form.Item>}
            </Form>
          </div>}
          {!register && <div className="auth-create"> Нет учетной записи? <div className="auth-create-link" onClick={() => setRegister(true)}>Создать</div></div>}
          {divBusy}
        </div>
      </div>
    </div>
    {/* {contextHolder} */}
  </div>
}

export default Auth;